import { LogParams } from '../localeParams'

const logsEN: LogParams = {
  success: {
    created: 'Created',
  },
  error: {
    failed: 'Failed',
  },
  installer: {
    welcomeMsg: '🔥 Welcome to the solv installer 🔥',
    description: 'solv is born and ready for running Solana Validator Nodes 🚀',
  },
}

export default logsEN
